export const firebaseConfig = {
    apiKey: "AIzaSyD1hjIU_YwTZQ3OUrWetVROCZUxFW9PRmc",
    authDomain: "distributely-37a84.firebaseapp.com",
    projectId: "distributely-37a84",
    storageBucket: "distributely-37a84.firebasestorage.app",
    messagingSenderId: "6142668877",
    appId: "1:6142668877:web:ecf4fee17a317621df2c04"
  };